"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _index = _interopRequireDefault(require("./styles/index"));
var _typography = require("../../theme/base/typography");
var _Tabs = require("./Tabs");
/**
 * ### `combineSizeWithVariant`
 * A function that takes in the `size` value, and the
 * `variant` value. The default-like styling for the `size` prop is merged with the styling from the
 * `variant` and a combined styleProp object is returned.
 *
 * @function combineSizeWithVariant
 * @param {string} args.size - The size of Tabs component
 * @param {string} args.variant - The style variant for the Text component
 * @returns {Object} An object containing the merged styleProps from the `variant` and the `size` props
 */

var combineSizeWithVariant = function combineSizeWithVariant(_ref) {
  var _fontSizeMapping;
  var size = _ref.size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'line' : _ref$variant;
  var fontSizeMapping = (_fontSizeMapping = {}, (0, _defineProperty2["default"])(_fontSizeMapping, _Tabs.SIZE_SMALL, _typography.fontSizes.xs), (0, _defineProperty2["default"])(_fontSizeMapping, _Tabs.SIZE_BODY, _typography.fontSizes.base), (0, _defineProperty2["default"])(_fontSizeMapping, _Tabs.SIZE_HEADING, _typography.fontSizes.lg), _fontSizeMapping);
  var styleProps = _index["default"].variants["".concat(variant)];
  styleProps.tab.fontSize = fontSizeMapping[size];
  return styleProps;
};
var _default = exports["default"] = combineSizeWithVariant;